import { Checkbox, Grid, Typography } from "@material-ui/core";
import Dialog from "components/Dialog";
import useText from "constants/text";
import React from "react";
import { ProductIcon } from "ui/Icons";
import { historyStyles } from "../styles";

interface FilterStatusProps {
  open: boolean;
  pickupChecked: boolean;
  dropOffChecked: boolean;
  fromStockChecked: boolean;
  closed: () => void;
  confirm: () => void;
  changePick: (e: React.ChangeEvent<HTMLInputElement>) => void;
  changeDrop: (e: React.ChangeEvent<HTMLInputElement>) => void;
  changeFrom: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const FilterStatus = ({
  open,
  fromStockChecked,
  dropOffChecked,
  pickupChecked,
  closed,
  changePick,
  changeDrop,
  changeFrom,
  confirm,
}: FilterStatusProps) => {
  const { text } = useText();
  const styles = historyStyles();

  return (
    <Dialog
      title={text.all.filter_by_task}
      open={open}
      maxWidth="md"
      handleConfirm={confirm}
      handleClose={closed}
      confirmButtonTitle={text.all.validate}
      cancelButtonTitle={text.all.cancel}
    >
      <Grid container spacing={2} direction="row" className={styles.gridContainer}>
        <Grid className={styles.searchPickup} xs={12} md={3}>
          <Checkbox color="primary" onChange={changePick} checked={pickupChecked} name="pickup" />
          <ProductIcon />
          <Typography className={styles.typographyStyled}>{text.all.pickup}</Typography>
        </Grid>
        <Grid className={styles.searchDropOff} xs={12} md={3}>
          <Checkbox color="primary" onChange={changeDrop} checked={dropOffChecked} name="dropOff" />
          <ProductIcon color="#faecca" />
          <Typography className={styles.typographyStyled}>{text.all.drop_off_label}</Typography>
        </Grid>
        <Grid className={styles.searchFromStock} xs={12} md={3}>
          <Checkbox color="primary" onChange={changeFrom} checked={fromStockChecked} name="fromStock" />
          <ProductIcon color="#bdbdbd" />
          <Typography className={styles.typographyStyled}>{text.all.from_stock_label}</Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};
